import { useState } from 'react';
import { useHasMenu } from '../../../../auth/access';
import { SectionTitle } from '../../../shared/components';
import AdminFeedback from '../components/AdminFeedback';
import FeedbackForm from '../components/FeedbackForm';

export default function DisciplineBoardPage() {
  // Reviewing and acting on reports is the APPROVE action of the Discipline Board (admin always).
  const canReview = useHasMenu('hr.discipline', 'APPROVE');

  const [shouldRefresh, setShouldRefresh] = useState(false);

  return (
    <div className='column gap-4'>
      <SectionTitle title='Discipline Board' />
      <FeedbackForm onFeedbackSubmitted={setShouldRefresh} />

      {canReview && (
        <AdminFeedback shouldRefresh={shouldRefresh} setShouldRefresh={setShouldRefresh} />
      )}
    </div>
  );
}
